

import config from "../config.json";
import profileEdit from '../Images/contact.jpg'
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import { toast } from "react-toastify";
import QrCodeAll from './QrCodeAll'
import QrCodePet from './QrCodePet'
import './QrCode.css'
export default function QrCode() {
    let navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [code, setCode] = useState("")
    useEffect(() => {
        setCode(searchParams.get('code'));
        // http.logout();
        // toast.error('پارامتر های ورودی کامل نیست', { theme: "colored" });
        //navigate('/login' );       

    }, []);
    useEffect(() => {
        if (code)
            QrCodeRead(code)
    }, [code]);
    const [previewImge, setPreviewImge] = useState(null);
    const [form, setForm] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const QrCodeRead = async (id) => {
        setIsLoading(true);
        await Services.QrCodeRead(id)
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode == 1) {
                    navigate(`/register/${code}`)
                    return
                }
                if (data.errorCode == 2) {
                    console.log('pet2');
                    window.location.replace(`https://babypet.noronyar.com/QrCode/Read?code=${code}`);
                    toast.success("لطفا تا انتقال به سایت مربوطه شکیبا باشید");
                    return
                }
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    setForm(null)
                    return
                }
                setForm(data)
                setPreviewImge(`${config.apiUrl}/pic/${data.payload.id}.jpg?${new Date().getTime()}`);
                if (data.payload.mode == "Pet") {
                    console.log('pet');
                    window.location.replace(`https://babypet.noronyar.com/QrCode/Read?code=${code}`);
                    toast.success("لطفا تا انتقال به سایت مربوطه شکیبا باشید");
                } else
                    console.log('normal tag')
            })
            .catch(err => {
                setIsLoading(false);
            });
    }



    return (
        <>


            {isLoading &&
                <div className="row  mt-3">
                    <div className="col text-white">
                        <span className="me-2">در حال دریافت اطلاعات ...</span>
                        <div className="spinner-border spinner-border-sm" role="status" />
                    </div>
                </div>}
            {/*!isLoading && form != null && form.payload != null && form.payload.mode == "Pet" &&
                <QrCodePet data={form} />
            */}
            {!isLoading && form != null && form.payload != null && form.payload.mode != "Pet" &&
                <>
                    <div className="row mb-2"  >
                        <div className="col-auto  d-flex align-items-center justify-content-center">
                            <img
                                src={previewImge ? previewImge : profileEdit}
                                className=''
                                id="picProfile"
                                onError={() => { setPreviewImge(null) }}
                            />
                        </div>

                        <div className="col">
                            {'displayName' in form.payload && form.payload.displayName != "" &&
                                <div className="row">
                                    <div className="col   "  >
                                        <p>
                                            <span className="text-white me-1">این وسیله متعلق به </span>
                                            <span className="mx-1 text-danger me-1">{form.payload.displayName}</span>
                                            <span className="text-white ms-1">است </span>
                                        </p>
                                    </div>
                                </div>
                            }
                            {'comment' in form.payload && form.payload.comment != "" &&
                                <div className="row">
                                    <div className="col   "  >
                                        <p>
                                            <span className="text-white me-1">پیام مالک </span>
                                            <span className="mx-1 text-white me-1">{form.payload.comment}</span>
                                        </p>
                                    </div>
                                </div>
                            }
                        </div>

                    </div>

                </>}
            {!isLoading && form != null && <QrCodeAll data={form} code={code} />}


        </>

    );

}
